import { preventAll, preventDefault } from './utils';
export var getTouchY = function getTouchY(event) {
  return event.changedTouches[0].clientY;
};
var elementCouldBeScrolled = function elementCouldBeScrolled(node) {
  return window.getComputedStyle(node).overflowY !== 'hidden';
};
export var handleScroll = function handleScroll(endTarget, event, sourceDelta, preventOnly) {
  if (preventOnly === void 0) {
    preventOnly = false;
  }
  var delta = sourceDelta; // find scrollable target

  var target = event.target;
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _target = target,
      scrollTop = _target.scrollTop,
      scrollHeight = _target.scrollHeight,
      clientHeight = _target.clientHeight;
    var elementScroll = scrollHeight - clientHeight - scrollTop;
    if (scrollTop || elementScroll) {
      if (elementCouldBeScrolled(target)) {
        availableScroll += elementScroll;
        availableScrollTop += scrollTop;
      }
    }
    target = target.parentNode;
  } while (endTarget.contains(target));
  if (isDeltaPositive && delta > availableScroll) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && -delta > availableScrollTop) {
    shouldCancelScroll = true;
  } // cancel scroll

  if (shouldCancelScroll) {
    if (preventOnly) {
      preventDefault(event);
    } else {
      preventAll(event);
    }
  }
};